import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import equipmentlist from '../assets/equipments/equipment-list.jpeg';


const EquipmentList = () => {
  const equipmentCategories = [
    {
      category: 'CNC Machining Centers',
      items: [
        '3-Axis CNC Vertical Machining Centers',
        '4-Axis CNC Horizontal Machining Centers',
        '5-Axis CNC Machining Centers',
        'CNC Turning Centers and Lathes',
        'Swiss-Type CNC Screw Machines',
      ],
    },
    {
      category: 'Cutting Equipment',
      items: [
        'Laser Cutting Systems (CO2 and Fiber)',
        'Plasma Cutting Tables',
        'Water Jet Cutting Systems',
        'Band Saws and Cut-Off Machines',
        'Shears and Plate Cutting Equipment',
      ],
    },
    {
      category: 'Forming & Fabrication',
      items: [
        'CNC Press Brakes (up to 500 ton)',
        'Hydraulic and Mechanical Press Brakes',
        'Roll Forming Machines',
        'Plate Rolling Equipment',
        'Punch Presses and Turret Punches',
      ],
    },
    {
      category: 'Welding Equipment',
      items: [
        'TIG, MIG, and Stick Welding Stations',
        'Robotic Welding Systems',
        'Submerged Arc Welding Equipment',
        'Stud Welding Machines',
        'Spot and Resistance Welding',
      ],
    },
    {
      category: 'EDM & Grinding',
      items: [
        'Wire EDM Machines',
        'Ram EDM Equipment',
        'Surface Grinding Machines',
        'Cylindrical Grinding Equipment',
        'Tool and Cutter Grinders',
      ],
    },
    {
      category: 'Testing & Inspection',
      items: [
        'Coordinate Measuring Machines (CMM)',
        'Hydrostatic Testing Equipment',
        'Ultrasonic Testing (UT) Systems',
        'Radiographic Testing (RT) Equipment',
        'Hardness Testing Equipment',
      ],
    },
    {
      category: 'Material Handling',
      items: [
        'Overhead Bridge Cranes (up to 20 ton)',
        'Jib Cranes and Gantry Systems',
        'Forklifts and Material Movers',
        'Lifting and Rigging Equipment',
      ],
    },
  ];

  return (
    <div className="min-h-screen pt-20" data-testid="equipment-list-page">
      <section className="relative py-20 px-4 sm:px-6 lg:px-8 overflow-hidden h-[30rem]" data-testid="equipment-list-hero">
        <div className="absolute inset-0">
          <img
            src={equipmentlist}
            alt="Equipment List"
            className="w-full h-full object-cover"
          />
            <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent"></div>
        </div>
        <div className="max-w-7xl mx-auto relative z-10 pt-24">
          <h1 className="text-4xl sm:text-5xl font-bold text-white heading-font mb-6" data-testid="equipment-list-heading">
            Equipment List
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl">
            Our 60,000 square foot facility houses a comprehensive array of state-of-the-art manufacturing equipment.
          </p>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white" data-testid="equipment-list-content">
        <div className="max-w-7xl mx-auto">
          <div className="space-y-8">
            {equipmentCategories.map((category, index) => (
              <div key={index} className="bg-gray-50 rounded-2xl p-8" data-testid={`equipment-category-${index}`}>
                <h2 className="text-2xl font-bold text-gray-900 heading-font mb-6">{category.category}</h2>
                <ul className="grid md:grid-cols-2 gap-4">
                  {category.items.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-start space-x-3" data-testid={`equipment-item-${index}-${itemIndex}`}>
                      <CheckCircle2 className="w-5 h-5 text-blue-700 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50" data-testid="equipment-note">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-gray-600">
            This list represents our core equipment capabilities. We continuously invest in new technology to meet evolving manufacturing demands. Contact us to discuss your specific equipment requirements.
          </p>
        </div>
      </section>
    </div>
  );
};

export default EquipmentList;